import ServiceProviderReviewInfo from "./ServiceProviderReviewInfo";
import ServiceProviderReviewInfoDetails from "./ServiceProviderReviewInfoDetails";

export {ServiceProviderReviewInfo, ServiceProviderReviewInfoDetails}